/**
 * Returns the input parameter without any modifications.
 *
 * @template T - The type of the input parameter.
 * @param {T} first - The parameter to be returned.
 * @returns {T} The same parameter that was passed in.
 */
export function identity<T>(first: T): T {
	return first;
}
